import React, { useState, useEffect } from 'react';
import { RIFieldsLive, RIFieldsUAT } from '../data/SalesforceFields';
import { useStaticQuery, graphql } from 'gatsby';
import RegisterInterestWrapper from '../components/wrappers/RegisterInterestWrapper';
import { handleDate } from '../util/util';
const RegisterInterestForm = ({
  selectedAddress,
  setSelectedAddress,
  region,
  forceReferralCode,
  defaultSource,
  leadSource,
  showSalesFields,
  isModularBlock,
  successPath,
  isHumanHelp,
  alreadyACustomer,
}) => {
  const [textarea, setTextarea] = useState();
  const [contractDate, setContractDate] = useState();
  const [message, setMessage] = useState('');
  const [followUpDate, setFollowUpDate] = useState();
  const [defaultFormData, setDefaultFormData] = useState({});

  const sfFields =
    process.env.NODE_ENV === 'development' ||
    process.env.GATSBY_ENVIRONMENT === 'development'
      ? RIFieldsUAT
      : RIFieldsLive;

  return (
    <RegisterInterestWrapper
      isHumanHelp={isHumanHelp}
      isModularBlock={isModularBlock}
      selectedAddress={selectedAddress}
      setSelectedAddress={setSelectedAddress}
      region={region}
      forceReferralCode={forceReferralCode}
      defaultSource={defaultSource}
      leadSource={leadSource}
      showSalesFields={showSalesFields}
      successPath={successPath}
      alreadyACustomer={alreadyACustomer}
      setContractDate={setContractDate}
      contractDate={contractDate}
      followUpDate={followUpDate}
      defaultFormData={defaultFormData}
      setDefaultFormData={setDefaultFormData}
      sfFields={sfFields}
    >
      <div className="form-input-inner column-1">
        <label>
          Email<span>*</span>
        </label>
        <input
          type="email"
          placeholder="Email address"
          name={sfFields.email}
          defaultValue={defaultFormData?.email}
          required
          onChange={(event) => event.target.setCustomValidity('')}
          role={showSalesFields && 'presentation'}
        />
      </div>
      <div className="form-input-inner column-3">
        <label>
          Contact Number<span>*</span>
        </label>
        <input
          type="tel"
          pattern="^(?:0|\+?44)(?:\d\s?){9,10}$"
          placeholder="Contact number"
          defaultValue={defaultFormData?.phoneNumber}
          name={sfFields.phone}
          required={!showSalesFields}
          role={showSalesFields && 'presentation'}
        />
      </div>
      {!isHumanHelp && (
        <div className="form-input-inner column-1  form-label-visible">
          <label>How did you hear about us?</label>
          <div className="form-select-arrow">
            <select
              onChange={(event) => {
                setTextarea(event.target.value);
              }}
              id={sfFields.hearAboutUs}
              name={sfFields.hearAboutUs}
              defaultValue={defaultSource ?? defaultFormData?.hearAboutUs}
            >
              <option value="">--None--</option>
              <option value="Petrol pump">Petrol pump</option>
              <option value="Roundabout">Roundabout</option>
              <option value="Supermarket">Supermarket</option>
              <option value="TV advert">TV advert</option>
              <option value="Leaflet or Flyer through the post">
                Leaflet or Flyer through the post
              </option>
              <option value="Email">Email</option>
              <option value="Social Media (Facebook, Twitter, etc)">
                Social Media (Facebook, Twitter, etc)
              </option>
              <option value="Search Engine (Google, Bing, etc)">
                Search Engine (Google, Bing, etc)
              </option>
              <option value="Local event">Local event</option>
              <option value="Football club">Football club</option>
              <option value="Recommendation">Recommendation</option>
              <option value="Lit Fibre representative at my door">
                Lit Fibre Representative at my door
              </option>
              <option value="Lit Fibre engineer">Lit Fibre engineer</option>
              <option value="Customer reviews e.g. Trustpilot">
                Customer reviews e.g. Trustpilot
              </option>
              <option value="Comparison website">Comparison website</option>
              <option value="Radio advert">Radio advert</option>
              <option value="News">News</option>
              <option value="Northgate School - Bishops Stortford">
                Northgate School - Bishops Stortford
              </option>
              <option value="Clacton FC">Clacton FC</option>
              <option value="Woodbridge Town FC">Woodbridge Town FC</option>
              <option value="Other">Other</option>
            </select>
          </div>
          {textarea === 'Other' && (
            <div className="form-input-inner column-3">
              <label>Other - Please specify:</label>
              <textarea
                maxLength={20}
                className="message--textarea"
                rows="3"
                wrap="soft"
                id={sfFields.otherSource}
                name={sfFields.otherSource}
              ></textarea>
            </div>
          )}
        </div>
      )}
      {!isHumanHelp && (
        <div className="form-input-inner column-3 form-label-visible">
          <label>Current Provider</label>
          <div className="form-select-arrow">
            <select
              id={sfFields.provider}
              name={sfFields.provider}
              title="Current Provider"
              defaultValue={defaultFormData?.currentProvider}
            >
              <option value="">I don’t have a provider</option>
              <option value="BT">BT</option>
              <option value="Sky">Sky</option>
              <option value="Virgin">Virgin</option>
              <option value="TalkTalk">TalkTalk</option>
              <option value="EE">EE</option>
              <option value="Plusnet">Plusnet</option>
              <option value="Post Office">Post Office</option>
              <option value="Pop Telecom">Pop Telecom</option>
              <option value="Vodafone">Vodafone</option>
              <option value="My provider is not listed">
                My provider is not listed
              </option>
            </select>
          </div>
        </div>
      )}
      {isHumanHelp && (
        <div className="form-input-inner column-span">
          <label htmlFor="Message">Anything else we need to know?</label>
          <textarea
            minLength={10}
            id={sfFields.humanHelpMessage}
            name={sfFields.humanHelpMessage}
            rows={3}
            value={message}
            placeholder="Enter your message"
            onChange={(e) => setMessage(e.target.value)}
          />
          <input
            name={sfFields.alreadyCustomer}
            id={sfFields.alreadyCustomer}
            value={alreadyACustomer ? 1 : 0}
            hidden
          />
        </div>
      )}
      {!isHumanHelp && (
        <div className="form-input-inner column-1">
          <div className="form-input-date">
            <label>Contract End Date</label>
            <input
              type="date"
              placeholder="End date"
              defaultValue={defaultFormData?.contractEndDate}
              onChange={(e) => handleDate(e, setContractDate)}
            />
          </div>
        </div>
      )}

      {showSalesFields && (
        <>
          {' '}
          <div className="form-input-inner column-3">
            <div className="form-input-date">
              <label>
                Follow up date<span>*</span>
              </label>
              <input
                type="date"
                required
                onChange={(e) => handleDate(e, setFollowUpDate)}
                min={new Date().toLocaleDateString('fr-ca')}
              />
            </div>
          </div>
        </>
      )}
      {showSalesFields && (
        <div className="form-input-inner column-3">
          <label>Notes</label>
          <textarea name={sfFields.salesNotes} id={sfFields.salesNotes} />
        </div>
      )}
    </RegisterInterestWrapper>
  );
};

export default RegisterInterestForm;
const imageQuery = () =>
  useStaticQuery(graphql`
    {
      datoCmsSimpleWebsitePageModel(slug: { eq: "legal/privacy-policy" }) {
        title
        slug
        simpleModularContent {
          ...ModularSimpleHero
          ...ModularParagraph
          ...ModularSimpleContent
        }
      }
    }
  `);
